export type YesNoDictionariesTranslation = {
  NO: string;
  YES: string;
};

export const yesNoDictionariesTranslation: YesNoDictionariesTranslation = {
  NO: 'Nie',
  YES: 'Tak',
};
